module.exports = __webpack_public_path__ + "img/loading.3c7688e6.gif";